import { InputFields } from '@datacamp/input-fields';
import { useMultiStepInstructionsContext } from '@datacamp/multi-step-instructions';
import React from 'react';
import { useSelector } from 'react-redux';
import selectLastSubmission from '../selectors/selectLastSubmission';
import { MultipleChoice } from './MultipleChoice';
import { MultipleChoiceWithSolutionItems } from './MultipleChoiceWithSolutionItems';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const AnswerPanel = _ref => {
  let {
    bottomLeftContent,
    checkExercise,
    exercise,
    exerciseId,
    submitLabel
  } = _ref;
  const lastSubmission = useSelector(state => selectLastSubmission(state, exerciseId));
  const {
    isSolutionDisplayed
  } = useMultiStepInstructionsContext();
  switch (exercise.question.flavor) {
    case 'DownloadFilesExcelOpenQuestion': // Similar behaviour as Open question
    case 'Open':
      {
        var _ref2, _lastSubmission$submi, _exercise$progress;
        const lastAttempts = (_ref2 = (_lastSubmission$submi = lastSubmission === null || lastSubmission === void 0 ? void 0 : lastSubmission.submittedCode) !== null && _lastSubmission$submi !== void 0 ? _lastSubmission$submi : (_exercise$progress = exercise.progress) === null || _exercise$progress === void 0 ? void 0 : _exercise$progress.last_attempt) === null || _ref2 === void 0 ? void 0 : _ref2.split('\n');
        return ___EmotionJSX("div", {
          className: "dc-panel__body"
        }, ___EmotionJSX(InputFields, {
          bottomLeftContent: bottomLeftContent,
          checkExercise: checkExercise,
          items: exercise.question.openQuestions,
          lastAttempts: lastAttempts,
          submitLabel: submitLabel
        }));
      }
    case 'DownloadFilesExcelMultipleChoice':
      return ___EmotionJSX(MultipleChoiceWithSolutionItems, {
        bottomLeftContent: bottomLeftContent,
        checkExercise: checkExercise,
        customQuestion: exercise.question.question,
        exerciseId: exerciseId,
        solutionItems: exercise.question.solutionItems,
        submitLabel: submitLabel
      });
    case 'PureMultipleChoice':
      return ___EmotionJSX(MultipleChoice, {
        bottomLeftContent: bottomLeftContent,
        checkExercise: checkExercise,
        customQuestion: exercise.question.question,
        exerciseId: exerciseId,
        feedback: exercise.question.feedback,
        isSolutionDisplayed: isSolutionDisplayed,
        possibleAnswers: exercise.question.possible_answers,
        submitLabel: submitLabel
      });
    default:
      throw new Error('Flavor not found');
  }
};